import {useCallback, useEffect, useRef, useState} from 'react';
import styles from './index.module.scss';
import {isNumber} from 'lodash-es';
import Icon from '@/components/Icon';
import {DocWordCloseSvg} from '@/icons';
import loadingImg from '@/assets/img/loading.png';
import {useIntl} from 'react-intl';
import {Popper, PopperTrigger} from '@baidu/luffy-comp-popper';
import sdk from '@/sdk';
import {EDITOR_MODE} from '@/Constant';

interface StatisticCountProps{
    docWordNum?: {
        totalWordCount: number;
        selectedWordCount?: number;
    };
    documentMode?: EDITOR_MODE;
    demoMode?: boolean;
}

interface INewGuide{
    onClose:()=>void;
}

const NewGuide:React.FC<INewGuide> = ({onClose: handleClose}) => {
    const intl = useIntl();
    return (
        <div className={styles.guideRoot} onClick={(ev: React.MouseEvent<HTMLDivElement>) => ev.stopPropagation()}>
            <div className={styles.guideWord}>{intl.formatMessage({id: 'docWordCount'})}</div>
            <div onClick={handleClose}>
                <Icon svg={DocWordCloseSvg} />
            </div>
        </div>
    );
};

export default function StatisticCount(props: StatisticCountProps) {
    const {docWordNum, documentMode, demoMode} = props;
    const [loading, setLoading] = useState(true);
    const [guideVisible, setGuideVisible] = useState(false);
    const docWordCountIsRead = sdk.as.user?.settings?.newGuide?.docWordCountIsRead;
    const target = useRef<any>();

    useEffect(() => {
        if (docWordNum) {
            setLoading(false);
        }
    }, [docWordNum]);

    // 初始化的时候确定是否要打开新手引导
    // 进入演示模式后关闭新手引导
    useEffect(() => {
        if (docWordCountIsRead) {
            return;
        }
        if (demoMode) {
            setGuideVisible(false);
            return;
        }
        if (documentMode && [EDITOR_MODE.preview, EDITOR_MODE.edit, EDITOR_MODE.meeting].includes(documentMode)) {
            setGuideVisible(true);
        } else {
            setGuideVisible(false);
        }
    }, [docWordCountIsRead, documentMode, demoMode]);

    function getWordCont(totalWordCount?: number, selectedWordCount?: any) {
        if (isNumber(selectedWordCount)) {
            return `${selectedWordCount}/${totalWordCount} 个字`;
        }
        return `${totalWordCount} 个字`;
    }

    const handleCloseGuide = useCallback(() => {
        setGuideVisible(false);
        sdk.as.updateNewGuide({
            docWordCountIsRead: true,
        }).catch(err => console.error(err));
    }, []);

    return <>
        <div
            className={styles.wordRoot}
        >
            {
                loading
                    ? <div className={styles.loadWord}>
                        <img src={loadingImg} className={styles.loading} alt="" />
                        <span>字数统计中...</span>
                    </div>
                    :
                    <PopperTrigger visible={guideVisible} target={target.current}>
                        <div className={styles.wordSty} ref={target}>
                            {getWordCont(docWordNum?.totalWordCount, docWordNum?.selectedWordCount)}
                        </div>
                        <Popper
                            className={styles.countPopover}
                            withArrow
                        >
                            <NewGuide onClose={handleCloseGuide} />
                        </Popper>
                    </PopperTrigger>
            }
            <div className={styles.divider}></div>
        </div>
    </>;
}
